import { API } from "@/services"

export const UPTIME_KUMA_GROUPS_ENDPOINTS = {
  create(category_id='',data={}){
    return API.Axios.error_capture.v1.request({
      url: `uptime-kuma/categories/${category_id}/groups`,
      method: 'POST',
      data,
    })
  },
  get(category_id='',params={}){
    return API.Axios.error_capture.v1.request({
      url: `uptime-kuma/categories/${category_id}/groups`,
      method: 'GET',
      params,
    })
  },
  findById(category_id='',id,params={}){
    return API.Axios.error_capture.v1.request({
      url: `uptime-kuma/categories/${category_id}/groups/${id}`,
      method: 'GET',
      params,
    })
  },
  delete(category_id='',id='',data={}){
    return API.Axios.error_capture.v1.request({
      url: `uptime-kuma/categories/${category_id}/groups/${id}`,
      method: 'DELETE',
      data,
    })
  },
  update(category_id='',id='',data={}){
    return API.Axios.error_capture.v1.request({
      url: `uptime-kuma/categories/${category_id}/groups/${id}`,
      method: 'PUT',
      data,
    })
  },
  availableServices(category_id='',id='',params={}){
    return API.Axios.error_capture.v1.request({
      url: `uptime-kuma/categories/${category_id}/groups/${id}/available-services`,
      method: 'GET',
      params,
    })
  },
  attachGroup(service_id='',category_id='',id='',data={}){
    return API.Axios.error_capture.v1.request({
      url: `uptime-kuma/${service_id}/categories/${category_id}/groups/${id}`,
      method: 'PATCH',
      data,
    })
  },
  deattachGroup(service_id='',category_id='',id='',data={}){
    return API.Axios.error_capture.v1.request({
      url: `uptime-kuma/${service_id}/categories/${category_id}/groups/${id}`,
      method: 'DELETE',
      data,
    })
  },
}